import { Form, Input, message } from "antd";
import { useCallback, useState } from "react";
import Modal from "../../../components/generic/Modal";
import httpClient from "../../../api/httpClient";
import { LockOutlined } from "@ant-design/icons";
import { parseError } from "../../../utils/shared";

const ChangePassword = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const handleOk = useCallback(
    async (values) => {
      try {
        setSubmitting(true);
        await httpClient.post("reset-password", values);
        message.success("Password updated successfully.");
        setIsModalOpen(false);
        form.resetFields();
      } catch (error) {
        parseError(error, true);
      } finally {
        setSubmitting(false);
      }
    },
    [form],
  );

  return (
    <>
      <div onClick={() => setIsModalOpen(true)}>
        <span
          role="img"
          aria-label="profile"
          className="anticon anticon-profile ant-dropdown-menu-item-icon cursor-pointer"
          style={{ cursor: "pointer" }}
        >
          <LockOutlined />
        </span>
        <span className="ant-dropdown-menu-title-content cursor-pointer">
          <span className="ant-dropdown-menu-title-content">
            Change Password
          </span>
        </span>
      </div>
      {isModalOpen && (
        <Modal
          title="Change Password"
          open
          onCancel={() => setIsModalOpen(false)}
          width={500}
          isProcessing={submitting}
          onOk={() => form.submit()}
          okText={"Reset"}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleOk}
            id="trt"
            disabled={submitting}
          >
            <Form.Item
              name="password"
              label="Current Password"
              rules={[
                {
                  required: true,
                  message: "Please enter current your password",
                },
                {
                  min: 8,
                  message: "Password must be at least 8 characters",
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter Current password"
              />
            </Form.Item>

            <Form.Item
              name="new_password"
              label="New Password"
              rules={[
                { required: true, message: "Please enter your new password" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value)
                      return Promise.reject(
                        new Error(
                          "New password must be different from the current password.",
                        ),
                      );
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter your new password"
              />
            </Form.Item>

            <Form.Item
              name="confirm_password"
              label="Confirm Password"
              dependencies={["password"]}
              rules={[
                { required: true, message: "Please confirm your password" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match"));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Confirm password"
              />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default ChangePassword;
